<!-- 协定享惠 -->
 <template> 
    <div> 
        <el-dialog v-dialogDrag title="优惠贸易协定享惠" :visible.sync="xiangHuiContentShow" width="60%" :before-close="handleClose" 
        :close-on-click-modal="false">
            <el-tag type="info">
                <i class="el-icon-warning"></i>
                如当前商品需要享惠，“优惠贸易协定项下原产地”与“原产地证明商品项号”必填！如无需享惠，请同时清空上述两个字段。
            </el-tag>
            <el-form ref="xiangHuiContentForm" :model="xiangHuiContentForm" label-width="170px" size="mini" style="margin-top: 10px;">
                <el-form-item label="原产地证明编号">
                    <el-input v-model="xiangHuiContentForm.declareId" placeholder="请输入原产地证明编号"></el-input>
                </el-form-item>
                <el-form-item label="优惠贸易协定代码">
                    <el-input v-model="xiangHuiContentForm.declareName" placeholder="请输入优惠贸易协定名称"></el-input>
                </el-form-item>
                <el-form-item label="优惠贸易协定项下原产地	">
                    <el-input v-model="xiangHuiContentForm.declarePlace" placeholder="请输入优惠贸易协定项下原产地"></el-input>
                </el-form-item>
                <el-form-item label="原产地证明商品项号">
                    <el-input v-model="xiangHuiContentForm.declareGoods" placeholder="请输入优原产地证明商品项号"></el-input>
                </el-form-item>
                <el-form-item label="原产地证明类型	">
                    <el-radio v-model="xiangHuiContentForm.declareType" label="1">原产地证书(C)</el-radio>
                    <el-radio v-model="xiangHuiContentForm.declareType" label="2">原产地声明(D)</el-radio>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleClose">关闭</el-button>
            </span>
        </el-dialog>
    </div>
 </template>
 <script> 
    export default { 
        props: {
            xiangHuiContentShow: {
                type: Boolean,
                default: false
            },
        },
        data() { 
            
            return { 
                xiangHuiContentForm:{},
            }
        },
        methods: { 
            handleClose() {
                this.$emit('xiangHuiContentClose', false);
            }
        }
    }
 </script>